import { Button, Modal } from '@ksyos/design-system';
import { useState } from 'react';
import { translateKey } from '@frontend/translate';
import { OrganizationContractSettingLogsTable } from './OrganizationContractSettingLogsTable';

interface IOrganizationContractSettingLogsProps {
    episodeCategoryId: string;
    organizationId: string;
}

export function OrganizationContractSettingLogs(props: IOrganizationContractSettingLogsProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <Button
                onClick={() => setIsModalOpen(true)}
                variant="link"
            >
                {translateKey('contractSettingLogs.linkToLogs')}
            </Button>
            <Modal
                closeOnEsc
                closeOnOverlayClick
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                size="large"
            >
                <Modal.Header>{translateKey('contractSettingLogs.modalTitle')}</Modal.Header>
                <Modal.CloseButton />
                <Modal.Body>
                    <OrganizationContractSettingLogsTable
                        episodeCategoryId={props.episodeCategoryId}
                        organizationId={props.organizationId}
                    />
                </Modal.Body>
                <Modal.Footer />
            </Modal>
        </>
    );
}
